import { toast as rhtoast } from "react-hot-toast";

export const dismiss = rhtoast.dismiss;

const getToastBackground = (type?: string) => {
  const background = "#333";
  switch (type) {
    case "success":
      return "#709e72FA";
    case "error":
      return "#c7352aFA";
    case "loading":
      return "#4bb1b1";
    default:
      return background;
  }
};

const getToastStyle = (type?: string) => ({
  width: "100%",
  zIndex: 100,
  padding: "16px",
  fontFamily: "inherit",
  fontSize: "1.2rem",
  background: getToastBackground(type),
  color: "#fff",
});

export const useToast = () => {
  return (message: string, icon?: string, type = "success", duration = 2500) =>
    rhtoast(message, {
      icon,
      position: "top-center",
      duration,
      style: getToastStyle(type),
    });
};

export const useDismissableToast = () => {
  const showToast = (message: string, icon?: string, type = "success", duration = 2500) => {
    const toastId = rhtoast(message, {
      icon,
      position: "top-center",
      duration,
      style: getToastStyle(type),
    });

    const cancel = () => rhtoast.dismiss(toastId);

    return { toastId, cancel };
  };

  return { showToast, dismiss: rhtoast.dismiss };
};
